import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-169aa261"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "roadmap-wrapper"
};

const _hoisted_2 = /*#__PURE__*/_createTextVNode("Roadmap");

const _hoisted_3 = {
  class: "block"
};
const _hoisted_4 = {
  class: "roadmap-item"
};

const _hoisted_5 = /*#__PURE__*/_createTextVNode("Phase 1");

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("ul", {
  style: {
    "list-style-position": "outside"
  }
}, [/*#__PURE__*/_createElementVNode("li", null, "Create InvestNFT channel in Alliance NFT members’ Discord"), /*#__PURE__*/_createElementVNode("li", null, "Launch base value feature"), /*#__PURE__*/_createElementVNode("li", null, "Launch reward feature"), /*#__PURE__*/_createElementVNode("li", null, "Host Alliance NFT online/offline event"), /*#__PURE__*/_createElementVNode("li", null, "Mint launches")], -1));

const _hoisted_7 = {
  class: "roadmap-item"
};

const _hoisted_8 = /*#__PURE__*/_createTextVNode("Phase 2");

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("ul", {
  style: {
    "list-style-position": "outside"
  }
}, [/*#__PURE__*/_createElementVNode("li", null, "Announce the first lottery winner"), /*#__PURE__*/_createElementVNode("li", null, "Reveal blindbox"), /*#__PURE__*/_createElementVNode("li", null, "Launch the tailor-made Quasi Staking feature"), /*#__PURE__*/_createElementVNode("li", null, "Launch withdraw feature")], -1));

const _hoisted_10 = {
  class: "roadmap-item"
};

const _hoisted_11 = /*#__PURE__*/_createTextVNode("Phase 3");

const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("ul", {
  style: {
    "list-style-position": "outside"
  }
}, [/*#__PURE__*/_createElementVNode("li", null, "Launch Bincentive membership upgrade feature"), /*#__PURE__*/_createElementVNode("li", null, "Unlock claim function"), /*#__PURE__*/_createElementVNode("li", null, "Update features’ utility"), /*#__PURE__*/_createElementVNode("li", null, "Expand Alliance NFT partners")], -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_landing_title = _resolveComponent("landing-title");

  const _component_content_text = _resolveComponent("content-text");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_landing_title, null, {
    default: _withCtx(() => [_hoisted_2]),
    _: 1
  }), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_content_text, null, {
    subtitle: _withCtx(() => [_hoisted_5]),
    smallContent: _withCtx(() => [_hoisted_6]),
    _: 1
  })]), _createElementVNode("div", _hoisted_7, [_createVNode(_component_content_text, null, {
    subtitle: _withCtx(() => [_hoisted_8]),
    smallContent: _withCtx(() => [_hoisted_9]),
    _: 1
  })]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_content_text, null, {
    subtitle: _withCtx(() => [_hoisted_11]),
    smallContent: _withCtx(() => [_hoisted_12]),
    _: 1
  })])])]);
}